import { useMutation } from "@apollo/client";
import { CLAIM_REFERRAL } from "graphql/mutations/loyalty";

const useLoyalty = () => {
  // Mutations
  const [claimReferral] = useMutation(CLAIM_REFERRAL);

  return { claimReferral };
};

export default useLoyalty;
